// Flat-scan task outline builder — the mobile-web counterpart to desktop's
// task-hierarchy.js buildTaskTree(). Depth is derived from leading whitespace
// (2 spaces = 1 level); a node "has children" if the immediately following
// task lines are strictly deeper, matching how markdown nesting reads visually.

const TASK_LINE_RE = /^([ \t]*)[-*][ \t]+\[[ xX]\]/;

export function buildTaskOutline(doc) {
  const nodes = [];
  for (let i = 1; i <= doc.lines; i++) {
    const line = doc.line(i);
    const m = TASK_LINE_RE.exec(line.text);
    if (!m) continue;
    const depth = Math.floor(m[1].replace(/\t/g, '  ').length / 2);
    nodes.push({ lineNumber: i, from: line.from, to: line.to, depth, hasChildren: false, childrenEndPos: null });
  }

  for (let idx = 0; idx < nodes.length; idx++) {
    const node = nodes[idx];
    let j = idx + 1;
    let lastChildTo = null;
    while (j < nodes.length && nodes[j].depth > node.depth) {
      lastChildTo = nodes[j].to;
      j++;
    }
    node.hasChildren = lastChildTo !== null;
    node.childrenEndPos = lastChildTo;
  }

  return nodes;
}

export function findOutlineNodeAt(nodes, lineFrom) {
  return nodes.find(n => n.from === lineFrom) || null;
}
